module.exports = __webpack_public_path__ + "static/media/socialFacebook.fecacb39.svg";